// extracted by css-extract-rspack-plugin
export default {"paymentErrorBanner":"paymentErrorBanner-ORMUFm"};